// extracted by mini-css-extract-plugin
export default {"wrapper":"Authen_wrapper__PJz9d"};